<template lang="pug">
.select-technician
  div
    //- BOTON MARCAR PAGO COMPLETO (CUANDO HAY UN PRESUPUESTO ABONADO)
    button.change-button(
      :disabled="disabled || loading"
      title="Marcar Pago Completo"
      @click="showModal()")
      b-spinner(v-if="loading" small)
      span {{ loading ? 'Procesando...' : 'Marcar Pago Completo' }}
    SamtekModal(
      v-model="showModalConfirm" 
      no-close-on-backdrop
      confirmText="Sí"
      cancelText="No"
      :loading="loading"
      @shown="onModalShown"
      @hide="onModalHide"
      @confirm="markPayment"
      @cancel="hideModal"
    )
        div.d-block.text-center
          h5 ¿Estás seguro de confirmar el pago completo del presupuesto?
</template>
<script>
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  components: {
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  name: 'ActionMarkFullPayment',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled', 'toast'],
  data() {
    return {
      showModalConfirm: false,
    }
  },
  methods: {
    ...mapActions('Quotations', ['markPaymentQuotation']),

    showModal() {
      this.showModalConfirm = true
    },

    onModalShown() {
      // Evento cuando se muestra el modal
    },

    onModalHide() {
      // Evento cuando se oculta el modal
    },

    hideModal() {
      this.showModalConfirm = false
    },

    async markPayment() {
      try {
        await this.executeWithLoading(async () => {
          const resp = await this.markPaymentQuotation({
            data: {
              estado_pago: 'COMPLETO',
            },
            id: this.ot.presupuesto_id,
          })

          this.hideModal()

          if (resp && resp.status === 200) {
            this.$bvToast.toast(resp.data, {
              variant: 'success',
            })
            this.$emit('changed')
          } else {
            this.$bvToast.toast(
              `Error al marcar pago cotización: ${resp.data}`,
              {
                variant: 'danger',
              }
            )
          }
        })
      } catch (error) {
        console.error('Error al marcar pago:', error)
        this.$bvToast.toast('Error al marcar pago', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
